// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { CdkPortal, TemplatePortal } from '@angular/cdk/portal';
import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { ASSETS } from '../../../../assets/assets';
import {
  OverlayHelper,
  overlayUserConfiguration,
} from '../../../../helpers/_old_helpers/overlayHelperClass';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import { InputTextComponent } from '../input-text/input-text.component';

@Component({
  selector: 'lbca-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrl: './timepicker.component.scss',
  imports: [InputTextComponent, CdkPortal, NgClass],
})
export class TimePickerRefComponent implements OnDestroy, AfterViewInit {
  readonly assets = inject(ASSETS);
  private errorPopup!: ErrorOverlayClass;

  private timePickerOverlay!: OverlayHelper;

  @ViewChild('mainElement', { static: true }) mainElement!: ElementRef;
  @ViewChild('templateAppend', { static: true }) templateAppend!: TemplatePortal;

  public labelValue = '';
  public helperTextValue = '';
  public isRequired = false;
  public isDisabled = false;
  public isLabeled = false;
  public isTabeled = false;
  public isEditable = false;
  public hasError = false;
  private modified = true;
  public fieldsLabels: any = {};
  public valueInput: any = null;

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }

  @Input()
  set value(val: string) {
    if (val) {
      this.valueInput = val;
    }
  }

  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = !value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }

  @Output('changeValue') changeEmmiter = new EventEmitter();

  @Output() focusState = new EventEmitter();

  @Output('setError') setErrorEmmiter = new EventEmitter();
  @Output('validStatus') validStatusEmmiter = new EventEmitter();

  constructor() {
    const overlay = inject(Overlay);
    const elementRef = inject(ElementRef);

    this.timePickerOverlay = new OverlayHelper(overlay);
    this.inicializateTimer();

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'end'
    );
  }

  completeTime = '00:00';
  hours: any[] = [];
  minutes: any[] = [];

  hideHour = false;
  hideMinutes = false;

  componetIconStyle = 'svg-icon-time bg-gray-600 transition duration-400 ease-in-out';

  public ngOnInit(): void {
    this.fieldsLabels = this.assets.labels.components.fields;
  }

  ngOnDestroy(): void {
    this.closePicker();
  }

  ngAfterViewInit(): void {
    const config: overlayUserConfiguration = {
      positionStrategy: 'flexible',
      scrollStrategy: 'close',
      connectedTo: this.mainElement,
      flexiblePositionStrategy: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
      ],
    };

    this.timePickerOverlay.setConfiguration(config);
  }

  // Bloqueia clicks dentro do pciker retirar o focus do mesmo
  public eventBlockFocusOut($event) {
    $event.preventDefault();
  }

  public setFocus(focus): void {
    this.focusState.emit(focus);
    if (focus) {
      this.componetIconStyle = 'svg-icon-time bg-primary transition duration-400 ease-in-out';
      this.openPicker();
    } else {
      this.componetIconStyle = 'svg-icon-time bg-gray-600 transition duration-400 ease-in-out';
      this.closePicker();
    }
  }

  public click() {
    const focusedElement = document.activeElement;
    if (focusedElement instanceof HTMLInputElement) {
      this.componetIconStyle = 'svg-icon-time bg-primary transition duration-400 ease-in-out';
      // this.openPicker();
      this.openPickerOverlay();
    } else {
      this.componetIconStyle = 'svg-icon-time bg-gray-600 transition duration-400 ease-in-out';
      this.closePicker();
    }
  }

  private openPickerOverlay(): void {
    this.timePickerOverlay.show(this.templateAppend);
    this.errorPopup.setFocus(true);
  }

  private closePicker(): void {
    setTimeout(() => {
      this.timePickerOverlay.close();
      this.errorPopup.setFocus(false);
    }, 150);
  }

  private openPicker() {
    this.modified = false;
    this.hideHour = false;
    this.hideMinutes = false;

    // Aqui da scroll para baixo, para certificar que o calendário caiba na página
    const availHeight = Math.round(window.innerHeight);
    const topDistance = Math.round(this.mainElement.nativeElement.getBoundingClientRect().top);

    const spaceDisponible = availHeight - (topDistance + 52);

    if (spaceDisponible < 378) {
      const spaceNecessary = 382 - spaceDisponible;
      const scroll = document.getElementById('main-scroll');
      const scrollPosition = Math.round(scroll!.scrollTop);
      const newPosition = scrollPosition + spaceNecessary;
      let scrollAnimation = scrollPosition;
      const sumConst = Math.round(spaceNecessary / 100);

      // Suavização do scroll
      let interval;
      interval = setInterval(() => {
        scrollAnimation += sumConst;
        scroll!.scrollTop = scrollAnimation;
      }, 4);

      setTimeout(() => {
        clearInterval(interval);
        scroll!.scrollTop = newPosition;
        setTimeout(() => this.openPickerOverlay(), 150);
      }, 402);
    } else {
      setTimeout(() => this.openPickerOverlay(), 150);
    }
  }

  // Monta os arrays dos pickers
  private inicializateTimer(): void {
    for (let index = 0; index < 24; index++) {
      this.hours.push(index < 10 ? '0' + index : index);
    }

    for (let index = 0; index < 60; index = index + 5) {
      this.minutes.push(index < 10 ? '0' + index : index);
    }
  }

  public select(time, position) {
    const splitted = this.completeTime.split(':');
    splitted[position] = time;

    this.valueInput = splitted.join(':');
    this.completeTime = this.valueInput;
    position === 0 ? (this.hideHour = true) : (this.hideMinutes = true);
    this.changeEmmiter.emit(this.valueInput);
  }

  public change($event) {
    this.valueInput = $event.target.value;

    const [hours, minutes] = this.valueInput.split(':');

    if (this.valueInput.length === 5) {
      if (hours > 23 || minutes > 59) {
        this.setErrorEmmiter.emit([{ field: 'time-picker', message: 'Inválido' }]);
      } else {
        this.changeEmmiter.emit(this.valueInput);
      }
    } else {
      $event.target.value = '';
      this.valueInput = '';
      this.changeEmmiter.emit('');
    }
  }
}
